import React from 'react';
import styles from './HandbookDoubleImageBlackBackground.module.scss';
import Title from '../../Components/Title/Title';
import Description from '../../Components/Description/Description';
import Button from '../../Components/Button/Button';
import DoubleImage from '../../Components/Image/DoubleImage';

const HandbookDoubleImageBlackBackground = ({ api }) => {
  return (
    <section
      id={api?.id}
      className={`wrapper ${styles.sectionHandbook}`}
      data-aos="fade-up"
      // data-aos-delay="100"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
      // data-aos-anchor-placement="top-center"
    >
      <div className={styles.sectionContainer}>
        <div
          className={styles.sectionContext}
          data-aos="fade-up"
          // data-aos-delay="300"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
          // data-aos-anchor-placement="top-center"
        >
          <Title
            title={api.attributes.title}
            type="lightTitle right-images"
            // animationData={{
            //   animation: 'fade-up',
            //   animationDelay: '500',
            //   animationDuration: '1000',
            //   animationEasing: 'easy-in-out',
            //   animationOnce: 'false',
            // }}
          />
          <Description
            api={api}
            type="lightDesc right-images"
            // animationData={{
            //   animation: 'fade-up',
            //   animationDelay: '500',
            //   animationDuration: '1000',
            //   animationEasing: 'easy-in-out',
            // }}
          />
          <Button
            api={api}
            type="lightButton right-images"
            // animationData={{
            //   animation: 'fade-up',
            //   animationDelay: '500',
            //   animationDuration: '1000',
            //   animationEasing: 'easy-in-out',
            //   animationAnchor: 'top-center',
            // }}
          />
        </div>
        <div
          className={styles.sectionImage}
          data-aos="fade-up"
          // data-aos-delay="100"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          <DoubleImage
            api={api}
            type="rightImages"
            animationData={{
              'data-aos': 'zoom-in',
              // 'data-aos-delay': '300',
              'data-aos-duration': '500',
              'data-aos-easing': 'easy-in-out',
              // 'data-aos-anchor-placement': 'top-center',
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default HandbookDoubleImageBlackBackground;
